export default __webpack_public_path__ + "static/media/training-tour4.8c8a45e8.svg";